module.exports = __webpack_public_path__ + "static/media/fiable.0836ec0a.svg";